export const StatementType = {
  Consolidated: 'Consolidated',
  Account: 'Account',
  Card: 'Card',
} as const;
export type StatementType = (typeof StatementType)[keyof typeof StatementType];
